<template>
  <div>
    <!-- 文案 begin -->
    <h5
      :style="{ color: 'rgba(' + MgmData.themeColor + ', 1)' }"
      class="text-center"
      v-html="title"
    />
    <div
      class="mx-auto"
      style="max-width: 150px"
    >
      <img
        :src="MgmData.themeSubImg"
        alt=""
        class="w-100"
      >
    </div>
    <div class="mb-3 text-center">
      <h5>
        {{ MgmData.bindingTitle }}
      </h5>
      <div v-html="MgmData.bindingDesc" />
    </div>
    <!-- 文案 end -->
    <div class="text-center">
      <b-button
        class="w-100 mx-auto d-block d-lg-inline-block"
        :style="{
          background: 'rgba(' + MgmData.themeColor + ', 1)',
          'border-color': 'rgba(' + MgmData.themeColor + ', 1)',
        }"
        @click="getLINEOpenId"
      >
        {{ $t("activity.bind-now") }}
      </b-button>
      <a
        href="#"
        class="d-inline-block py-2 font-size-md text-gray600"
        @click="showGiveUpBindPopup = true"
      >
        {{ $t("activity.give-up-bind") }}
      </a>
    </div>
    <Popup
      v-if="showGiveUpBindPopup"
      @confirm="goToMemberCenterWithCode"
      @cancel="showGiveUpBindPopup = false"
      @close="showGiveUpBindPopup = false"
    >
      <h5 class="alert-heading">
        {{ $t("activity.check-give-up-bind-title") }}
      </h5>
      <p class="text-break-word font-size-md">
        {{ $t("activity.check-give-up-bind-desc") }}
      </p>
    </Popup>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import Popup from '@/components/Popup.vue';

export default {
  components: {
    Popup,
  },
  data() {
    return {
      showGiveUpBindPopup: false,
    };
  },
  computed: {
    ...mapState(['activityWithoutPromise', 'companyId', 'memberSourceId']),
  },
  methods: {
    ...mapMutations(['setShowTerms']),
    getLINEOpenId() {
      const { params } = this.$route;
      params.page = 'MgmInvitedSSO';
      const queryString = new URLSearchParams(this.$route.params).toString();
      const isLocal = process.env.VUE_APP_IS_LOCAL !== undefined
        && process.env.VUE_APP_IS_LOCAL.toLowerCase() === 'true';
      const origin = window.location.origin + (isLocal ? '' : '/activity');
      const href = `${origin}/LINELoginJumpPage`;
      const redirectUrl = encodeURIComponent(`${href}?${queryString}`);
      const comUrl = JSON.parse(process.env.VUE_APP_USE_ENV)
        ? '${VUE_APP_API_COM_URL}'
        : process.env.VUE_APP_API_COM_URL;
      const lineLoginUrl = `${comUrl}api/v1/linecode?DirectUrl=${redirectUrl}&CompanyId=${this.companyId}&MemberSourceId=${this.memberSourceId}`;

      window.location.href = lineLoginUrl;
    },
  },
  props: {
    title: String,
    MgmData: {
      type: Object,
      default: () => ({}),
    },
    goToMemberCenterWithCode: Function,
  },
};
</script>
